/**
 * WorkOrders.api.js
 * ------------------
 * Centralized API functions for fetching and managing work order data.
 */

import axios from "axios";
import api from "../../../utils/api"; // Adjust if your path is different

/**
 * Fetch all work orders.
 * @returns {Promise<AxiosResponse>} Axios response with work order data.
 */
export const fetchWorkOrders = () => {
  return api.get(`/getWorkOrders`);
};

/**
 * Fetch all available work order statuses.
 * @returns {Promise<AxiosResponse>} Axios response with status data.
 */
export const fetchStatuses = () => {
  return api.get(`/statuses/workorders`);
};

/**
 * Fetch users allowed to be assigned to work orders (by role).
 * @returns {Promise<AxiosResponse>} Axios response with user data.
 */
export const fetchAssignableUsers = () => {
  return api.get(`/users-by-role`);
};

/**
 * Fetch available work order types.
 * @returns {Promise<AxiosResponse>} Axios response with work order type data.
 */
export const fetchWorkOrderTypes = () => {
  return api.get(`/workorder-types`);
};

/**
 * Fetch files attached to a specific work order.
 * @param {number|string} workOrderId - The ID of the work order.
 * @returns {Promise<AxiosResponse>} Axios response with file data.
 */
export const fetchWorkOrderFiles = (workOrderId) => {
  return api.get(`/workorder-files/${workOrderId}`);
};